import React from 'react'
import { TabList } from 'react-tabs'
import * as S from './styled'
import type { ListProps } from './types'

export const List = ({ direction = 'horizontal', style, children, ...other }: ListProps) => {
  return (
    <TabList {...other}>
      <S.ListContainer $direction={direction} style={style}>
        {children}
      </S.ListContainer>
    </TabList>
  )
}

List.tabsRole = 'TabList'
